var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6667 19.3333H39.3333V14.6666C39.3333 8.2266 34.1067 3 27.6667 3C21.2267 3 16 8.2266 16 14.6666V19.3333H13.6667C11.1 19.3333 9 21.4333 9 24V47.3333C9 49.8999 11.1 52 13.6667 52H41.6667C44.2333 52 46.3333 49.8999 46.3333 47.3333V24C46.3333 21.4333 44.2333 19.3333 41.6667 19.3333ZM27.6667 40.3333C25.1 40.3333 23 38.2333 23 35.6666C23 33.1 25.1 31 27.6667 31C30.2333 31 32.3333 33.1 32.3333 35.6666C32.3333 38.2333 30.2333 40.3333 27.6667 40.3333ZM34.9 19.3333H20.4333V14.6666C20.4333 10.6766 23.6767 7.4333 27.6667 7.4333C31.6567 7.4333 34.9 10.6766 34.9 14.6666V19.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockWhite);
export default __webpack_public_path__ + "static/media/lock-white.6e5178f4e236ae613d62c8c0df1069fb.svg";
export { ForwardRef as ReactComponent };